import { inject, provideAppInitializer } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { CoreService } from "../services/core.service";
import { DomainService } from "../services/domain.service";

export async function runMaintenanceCheck(coreService: CoreService, domain: string): Promise<void> {
  try {
    const response: any = await firstValueFrom(coreService.fetchMaintenanceStatus(domain));
    if (response?.status === "ok") {
      const result = response?.result?.[0];
      if (result?.ISONMAINTENANCE) coreService.redirectToMaintenance();
    }
  } catch (error) {
    console.error("Error fetching maintenance mode status:", error);
    coreService.redirectToMaintenance();
  }
}

export function initializeMaintenance(): () => Promise<void> {
  const coreService = inject(CoreService);
  const domainService = inject(DomainService);
  return () => runMaintenanceCheck(coreService, domainService.getDomain());
}

export const provideMaintenance = () =>
  provideAppInitializer(() => {
    const initializerFn = initializeMaintenance();
    return initializerFn();
  });
